// 16进制颜色值转化成rgba
export const hexToRgba = (hex, opacity) => {
  if (!hex) hex = '#ededed'
  let rgba =
    'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + (opacity || '1') + ')'
  return rgba
}
// rgba转化成16进制颜色值
export const rgbaTo16color = (color) => {
  let val = color
    .replace(/rgba?\(/, '')
    .replace(/\)/, '')
    .replace(/[\s+]/g, '')
    .split(',')
  let a = parseFloat(val[3] || 1),
    r = Math.floor(a * parseInt(val[0]) + (1 - a) * 255),
    g = Math.floor(a * parseInt(val[1]) + (1 - a) * 255),
    b = Math.floor(a * parseInt(val[2]) + (1 - a) * 255)
  return '#' + ('0' + r.toString(16)).slice(-2) + ('0' + g.toString(16)).slice(-2) + ('0' + b.toString(16)).slice(-2)
}

export const hexToRgb = (hexColor) => {
  // 去除 # 符号
  hexColor = hexColor.replace('#', '')
  // 提取红、绿、蓝分量的十六进制值
  var red = parseInt(hexColor.substring(0, 2), 16)
  var green = parseInt(hexColor.substring(2, 4), 16)
  var blue = parseInt(hexColor.substring(4, 6), 16)
  // 返回 RGB 值
  return red + ', ' + green + ', ' + blue
}

// 16进制颜色值,根据透明度转化成新的16进制颜色值
export const blendColor = (hexColor, opacity) => {
  // 将 16 进制颜色值转换为 RGB 值
  const red = parseInt(hexColor.slice(1, 3), 16)
  const green = parseInt(hexColor.slice(3, 5), 16)
  const blue = parseInt(hexColor.slice(5, 7), 16)

  // 计算新的 RGB 值
  const newRed = Math.round(opacity * red + (1 - opacity) * 255)
  const newGreen = Math.round(opacity * green + (1 - opacity) * 255)
  const newBlue = Math.round(opacity * blue + (1 - opacity) * 255)

  // 将 RGB 值转换为 16 进制颜色值
  const newHexColor = `#${newRed.toString(16)}${newGreen.toString(16)}${newBlue.toString(16)}`

  return newHexColor
}
